// latest: zhangmyh 2017-8-9 10:21 PM

import { Model } from 'common'
Model.define('materialclass.existed', {
  proxy: {},
  meta: {
    id: '',
    materialClassId: '',
    materialClassName: ''
  }
})

export default Model.create('materialclass.existed')



// WEBPACK FOOTER //
// ./src/data/model/materialClass/existed.js